import { render, staticRenderFns } from "./NoteComponent.vue?vue&type=template&id=2ae11404&"
import script from "./NoteComponent.vue?vue&type=script&lang=js&"
export * from "./NoteComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports